import { fetchPmaxOverviewTabData } from '@bingads-webui-campaign-legacy/dashboard-page/dashboard/data-fetch-pmax-overview';
import { WaterfallFilterStorage, WaterfallFilterType } from '@bingads-webui-campaign/filter-storage';

export function fetchDataForPmaxOverview({
  preferenceService, serverContext, resolve, reject,
}) {
  const waterfallFilterStorage = new WaterfallFilterStorage({
    preferenceService,
  });
  const filter = waterfallFilterStorage.getFilters([
    WaterfallFilterType.CampaignType,
    WaterfallFilterType.CampaignStatus,
    WaterfallFilterType.AdGroupStatus,
  ]);

  fetchPmaxOverviewTabData({
    filter, serverContext, preferenceService, resolve, reject,
  });
}
